import { buildApiUrl } from 'fake-db/apiConfig'
import Mock from '../../mock'
import jwt from 'jsonwebtoken'
import axios from 'axios.js'

const JWT_SECRET = 'PIXELCRM_SECRET_KEY'
const JWT_VALIDITY = '7 days'


Mock.onPost('/api/order/all').reply(async (config) => {
    try {
        await new Promise((resolve) => setTimeout(resolve, 1000))
        const { dateStart, dateStop } = JSON.parse(config.data);

        // console.log('должны получить список заказов за этот период = ',dateStart,dateStop);



        const response = await axios.post(buildApiUrl('order/getOrder/'), {
            DateOrderPull:{
                dateStart,dateStop
                // "dateStart":"20.01.2021",
                // "dateStop":"12.12.2022"
            },
            "Affiliate":{
                "active":0,
                "id":1
            }
        });
        const {error, errorInfo, result, message, data } = response.data;

        // console.log("Ответ от сервера по всем заказам",response);
        // console.log(error,errorInfo,result,message,data);
        const OrderList = data.OrderList;
        const AllStatusOrder = data.AllStatusOrder;


        if (!OrderList) {
            return [400, { message: 'Список заказов отсутствует' }]
        }

        // const accessToken = user.accessToken;

        return [
            200,
            {
                orderListServer: {
                    OrderList,
                    AllStatusOrder
                },
            },
        ]
    } catch (err) {
        console.error(err)
        return [500, { message: 'Internal server error' }]
    }
})


Mock.onPost('/api/order/getOrderInfo').reply(async (config) => {
    try {
        await new Promise((resolve) => setTimeout(resolve, 1000))
        const { idOrder } = JSON.parse(config.data);

        const response = await axios.post(buildApiUrl('order/getOrderInfo/'), {
            DateOrderPull:{
               idOrder
            },
            "Affiliate":{
                "active":0,
                "id":1
            }
        });
        const {error, errorInfo, result, message, data } = response.data;

        const OrderList = data.OrderList;

        if (!OrderList) {
            return [400, { message: 'Список заказов отсутствует' }]
        }

        return [
            200,
                OrderList
        ]
    } catch (err) {
        console.error(err)
        return [500, { message: 'Internal server error' }]
    }
})

Mock.onGet('/api/order/getAllStatus').reply(async (config) => {
    try {
        await new Promise((resolve) => setTimeout(resolve, 1000))
        // const { email, password } = JSON.parse(config.data);




        const response = await axios.get(buildApiUrl('order/getAllStatus/')
        );
        const {error, errorInfo, result, message, data } = response.data;

        // console.log("Ответ от сервера ",response.data);
        // console.log(error,errorInfo,result,message,data);
        const AllStatusOrder = data;


        if (!AllStatusOrder) {
            return [400, { message: 'Список статусов отсутствует' }]
        }

        // const accessToken = user.accessToken;

        return [
            200,
            {
                AllStatusOrder
            },
        ]
    } catch (err) {
        console.error(err)
        return [500, { message: 'Internal server error' }]
    }
})


Mock.onPost('/api/order/newOrder').reply(async (config) => {
    try {
        await new Promise((resolve) => setTimeout(resolve, 1000))
        const { newOrderData } = JSON.parse(config.data);



        const response = await axios.post(buildApiUrl('order/newOrder/'),{
            newOrderData
            }
        );
        const {error, errorInfo, result, message, data } = response.data;

        // console.log(error,errorInfo,result,message,data);
        const StatusNewOrders = result;


        if (!StatusNewOrders) {
            const errorPayload = response.data && typeof response.data === 'object'
                ? response.data
                : { message: 'Ошибка сохранения нового заказа' }
            return [response?.status === 403 ? 403 : 400, errorPayload]
        }

        // const accessToken = user.accessToken;

        return [
            200,
            response.data
        ]
    } catch (err) {
        console.error(err)
        return [err?.response?.status || 500, err?.response?.data || { message: 'Internal server error' }]
    }
})


Mock.onPost('/api/order/EditOrderData').reply(async (config) => {
    try {
        await new Promise((resolve) => setTimeout(resolve, 1000))
        const { EditOrderData } = JSON.parse(config.data);



        const response = await axios.post(buildApiUrl('order/EditOrderData/'),{
            EditOrderData
            }
        );
        const {error, errorInfo, result, message, data } = response.data;

        // console.log(error,errorInfo,result,message,data);
        const StatusNewOrders = result;


        if (!StatusNewOrders) {
            const errorPayload = response.data && typeof response.data === 'object'
                ? response.data
                : { message: 'Ошибка редактирования заказа' }
            return [403, errorPayload]
        }

        // const accessToken = user.accessToken;

        return [
            200,
                StatusNewOrders
        ]
    } catch (err) {
        console.error(err)
        return [err?.response?.status || 500, err?.response?.data || { message: 'Internal server error' }]
    }
})


Mock.onPost('/api/order/deleteOrder').reply(async (config) => {
    try {
        await new Promise((resolve) => setTimeout(resolve, 1000));

        const { idOrderDeleted, warehouseDisposition } = JSON.parse(config.data);



        const response = await axios.post(buildApiUrl('order/deleteOrder/'),{
            idOrderDeleted,
            warehouseDisposition,
            }
        );
        const { result } = response.data;
        const StatusDeletOrders = result;


        if (!StatusDeletOrders) {
            const errorPayload = response.data && typeof response.data === 'object'
                ? response.data
                : { message: 'Ошибка удаления заказа' }
            return [403, errorPayload]
        }

        // const accessToken = user.accessToken;

        return [
            200,
            StatusDeletOrders
        ]
    } catch (err) {
        console.error(err)
        return [err?.response?.status || 500, err?.response?.data || { message: 'Internal server error' }]
    }
})

Mock.onPost('/api/order/setStatusOrder').reply(async (config) => {
    try {
        await new Promise((resolve) => setTimeout(resolve, 1000));

        // console.log('В config пришло вот это ',config);
        const { idOrder,idStatus,warehouseDisposition } = JSON.parse(config.data);



        const response = await axios.post(buildApiUrl('order/setStatusOrder/'),{
            idOrder,idStatus,warehouseDisposition
            }
        );
        return [response?.status || 200, response?.data || {}]
    } catch (err) {
        console.error(err)
        return [err?.response?.status || 500, err?.response?.data || { message: err?.message || 'Internal server error' }]
    }
})

Mock.onPost('/api/order/warehouseDispositionPreview').reply(async (config) => {
    try {
        const { idOrder, idStatus, isDelete } = JSON.parse(config.data)
        const response = await axios.post(buildApiUrl('order/warehouseDispositionPreview/'), { idOrder, idStatus, isDelete })
        return [response?.status || 200, response?.data || {}]
    } catch (err) {
        return [err?.response?.status || 500, err?.response?.data || { message: err?.message || 'Не удалось проверить складской результат отмены' }]
    }
})

Mock.onPost('/api/order/setWorkerStatusOrder').reply(async (config) => {
    try {
        await new Promise((resolve) => setTimeout(resolve, 1000));

        // console.log('В config пришло вот это ',config);
        const { idOrder,idStatus, idWorker } = JSON.parse(config.data);



        const response = await axios.post(buildApiUrl('order/setWorkerStatusOrder/'),{
            idOrder,idStatus, idWorker
            }
        );
        return [response?.status || 200, response?.data || {}]
    } catch (err) {
        console.error(err)
        return [err?.response?.status || 500, err?.response?.data || { message: err?.message || 'Internal server error' }]
    }
})



Mock.onPost('/api/order/setTypePayment').reply(async (config) => {
    try {
        await new Promise((resolve) => setTimeout(resolve, 1000));

        // console.log('В config пришло вот это ',config);
        const { idOrder,idPayment,textTypePayment } = JSON.parse(config.data);



        const response = await axios.post(buildApiUrl('order/setTypePayment/'),{
            idOrder,idPayment,textTypePayment
            }
        );
        return [response?.status || 200, response?.data || {}]
    } catch (err) {
        console.error(err)
        return [err?.response?.status || 500, err?.response?.data || { message: err?.message || 'Internal server error' }]
    }
})

Mock.onPost('/api/order/list-v2').reply(async (config) => {
    try {
        await new Promise((resolve) => setTimeout(resolve, 400))
        const payload = JSON.parse(config.data || '{}');
        const { dateStart, dateStop, filters = {}, cursor = null, limit = 100, tariffContext = '' } = payload;

        const response = await axios.post(buildApiUrl('order/getOrderV2/'), {
            DateOrderPull: {
                dateStart,
                dateStop,
                filters,
                cursor,
                limit,
                tariffContext,
            },
            Affiliate: {
                active: Number(filters?.affiliateId || 0) > 0 ? 1 : 0,
                id: Number(filters?.affiliateId || 0)
            }
        });

        const raw = response?.data || {};
        const errorText = raw?.error || '';
        const errorInfo = raw?.errorInfo || raw?.text || '';
        const resultState = String(raw?.result || '').toLowerCase();
        const isBillingDenied = String(errorText).toLowerCase().indexOf('billing') >= 0;
        const isAccessDenied = String(errorText).toLowerCase().indexOf('access') >= 0;
        const hasServerError = !!errorText || resultState === 'error';
        if (hasServerError) {
            const statusCode = isBillingDenied || isAccessDenied ? 403 : 400;
            return [statusCode, {
                error: errorText || 'Error',
                errorInfo: errorInfo || (isBillingDenied ? 'Детальная аналитика недоступна по тарифу' : (isAccessDenied ? 'Нет доступа к просмотру заказов' : 'Ошибка загрузки заказов')),
                message: errorInfo || errorText || 'Ошибка загрузки заказов',
                result: 'error',
                __error: true,
            }];
        }

        const data = raw?.data || {};
        return [200, { orderListServerV2: data }];
    } catch (err) {
        console.error(err);
        const rawErr = err?.response?.data || {};
        return [err?.response?.status || 500, {
            error: rawErr?.error || 'Internal server error',
            errorInfo: rawErr?.errorInfo || rawErr?.message || err?.message || 'Internal server error',
            message: rawErr?.message || rawErr?.errorInfo || err?.message || 'Internal server error',
            result: 'error',
            __error: true,
        }];
    }
});

Mock.onPost('/api/order/delta-v2').reply(async (config) => {
    try {
        await new Promise((resolve) => setTimeout(resolve, 400))
        const payload = JSON.parse(config.data || '{}');
        const { dateStart, dateStop, filters = {}, sinceToken = 0 } = payload;

        const response = await axios.post(buildApiUrl('order/getOrderDeltaV2/'), {
            DateOrderPull: {
                dateStart,
                dateStop,
                filters,
                sinceToken
            },
            Affiliate: {
                active: Number(filters?.affiliateId || 0) > 0 ? 1 : 0,
                id: Number(filters?.affiliateId || 0)
            }
        });

        const data = response?.data?.data || {};
        return [200, { orderListDeltaV2: data }];
    } catch (err) {
        console.error(err);
        return [err?.response?.status || 500, err?.response?.data || { message: err?.message || 'Internal server error' }];
    }
});

Mock.onPost('/api/order/history-summary').reply(async (config) => {
    try {
        await new Promise((resolve) => setTimeout(resolve, 300));
        const payload = JSON.parse(config.data || '{}');
        const { idOrder } = payload;

        const response = await axios.post(buildApiUrl('order/getOrderHistorySummary/'), {
            DateOrderPull: { idOrder },
            Affiliate: { active: 0, id: 0 }
        });
        return [200, { orderHistorySummary: response?.data?.data || {} }];
    } catch (err) {
        console.error(err);
        return [500, { message: err?.response?.data?.message || err?.message || 'Internal server error' }];
    }
});

Mock.onPost('/api/order/history-full').reply(async (config) => {
    try {
        await new Promise((resolve) => setTimeout(resolve, 300));
        const payload = JSON.parse(config.data || '{}');
        const { idOrder, limit = 300 } = payload;

        const response = await axios.post(buildApiUrl('order/getOrderHistoryFull/'), {
            DateOrderPull: { idOrder, limit },
            Affiliate: { active: 0, id: 0 }
        });
        return [200, { orderHistoryFull: response?.data?.data || {} }];
    } catch (err) {
        console.error(err);
        return [500, { message: err?.response?.data?.message || err?.message || 'Internal server error' }];
    }
});

Mock.onPost('/api/order/execution-time-report').reply(async (config) => {
    try {
        const payload = JSON.parse(config.data || '{}');
        const response = await axios.post(buildApiUrl('order/getExecutionTimeReport/'), {
            DateOrderPull: {
                dateStart: payload.dateStart,
                dateStop: payload.dateStop,
                filters: payload.filters || {},
                detailsPage: payload.detailsPage || 0,
                detailsPerPage: payload.detailsPerPage || 25,
            },
            Affiliate: {
                active: Number(payload?.filters?.affiliateId || 0) > 0 ? 1 : 0,
                id: Number(payload?.filters?.affiliateId || 0),
            },
        });
        const raw = response?.data || {};
        if (raw?.error || String(raw?.result || '').toLowerCase() === 'error') {
            return [403, {
                error: raw?.error || 'Execution report error',
                message: raw?.errorInfo || raw?.message || 'Не удалось сформировать отчёт',
            }];
        }
        return [200, { executionTimeReport: raw?.data || {} }];
    } catch (err) {
        console.error('Ошибка отчёта времени исполнения', err?.response?.data || err);
        return [err?.response?.status || 500, err?.response?.data || { message: err?.message || 'Internal server error' }];
    }
});
